module.exports = __webpack_public_path__ + "annualreview2017/static/pdfs/focus-communities-environment.382e9c9.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/focus-communities-environment.pdf
// module id = 631
// module chunks = 0